import { JUDGE_IS_LOGIN } from '@store/officialStore/login';
import { CHECK_IP_LOCATION } from '@store/ipCheck';
import {
  jumpPnsWithToken,
  NEED_TO_JUMP_PNS_GAMEID
} from '@utiles/jumpWithToken';
import { mapState } from 'vuex';
import {
  GET_SEPC_GAME_INFO,
  GET_LASTED_STORE_ROLE
} from '@store/officialStore';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { errorReport404 } from '@utiles/errorReport';
const mainHost = globalConfig.getMainHost();
export const jumpErrorPage = () => {
  let hostName = mainHost;
  if (
    hostName === atob('M3N5dWEuY29t') ||
    hostName === atob('YmxhbmNvem9uZS5jb20=')
  ) {
    // 其实404路径不存在，后端根据ip跳转真实404
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/404`
    });
  } else if (hostName === atob('c2xmdW50YXAuY29t')) {
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/slfuntap/page404`
    });
  } else {
    errorReport404();
    window.location.href = getGlobalGetGotoLink({
      link: `//www.${hostName}/page404`
    });
  }
};

export default {
  computed: {
    ...mapState({
      passportToken: state => state.login.passportToken,
      gameId: state => state.gameId
    })
  },
  methods: {
    globalBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
        // 2024.08.08 邓智轩：需要检查的游戏，且IP为日本时，跳转pns站点
        let winLang = '';
        if (window.navigator) {
          winLang =
            globalConfig.getLanguages() ||
            window.navigator.language ||
            window.navigator.browserLanguage ||
            window.navigator.systemLanguage;
        } else {
          winLang = globalConfig.getLanguages();
        }
        if (NEED_TO_JUMP_PNS_GAMEID.includes(+this.gameId)) {
          if (winLang === 'ja-JP') {
            jumpPnsWithToken(this.passportToken);
            return;
          }
          this.$store.dispatch(CHECK_IP_LOCATION).then(ipRes => {
            if (ipRes.ISO_TWO_CODE == 'JP') {
              jumpPnsWithToken(this.passportToken);
            }
          });
        }
        if (!res) {
          return;
        }
        this.$store.dispatch(GET_LASTED_STORE_ROLE);
        let canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: this.$store.state.gameId
        });
        if (!canContinue) {
          jumpErrorPage();
        }
      });
    },
    jpBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN);
    }
  },
  created() {
    this.$store.getters.isJpPlatform
      ? this.jpBeforeCreate()
      : this.globalBeforeCreate();
  }
};
